import { CustomerReference, CustomerReferenceRef } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const createCustomerReference: (
  fetchContext: FetchContext,
  nominationId: number,
  customerReference: CustomerReference,
  accessToken?: string,
) => Promise<CustomerReferenceRef> = (fetchContext, nominationId, customerReference, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/nominations/${nominationId}/customer-references`, {
    method: 'POST',
    body: JSON.stringify(customerReference),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<CustomerReferenceRef>(fetchContext.errorStore, response, 'create customer reference'));
